import axios from "axios";
import { IWidgetResponse } from "../Base/Base.types";
import {IContainersPerMonth} from "./ContainersPerMonth.types";

export default class ContainersPerMonthApi {
    static async getData({queryKey}: any) {
        //eslint-disable-next-line
        const [_, rawQuery] = queryKey;
        try {
            let res = await axios.get(`/ContainersPerMonth`, {params: rawQuery});
            return res.data as IWidgetResponse<IContainersPerMonth>;
        } catch (e: any) {
            console.error('Could not get ContainersPerMonth data: ', e.message);
            return undefined;
        }
    }
}